<template>
	<div>
		<b-breadcrumb class="flex-nowrap m-0 rounded-0" :items="breadcrumbs"/>

		<loading-panel loading-text="Загрузка форм" v-if="isLoading && !months" />

		<div class="p-4" v-if="months && Array.isArray(months) && months.length > 0">
			<div v-for="n in 4">
				<div class="mb-3">Квартал {{ n }}</div>
				<div class="row">
					<template v-for="(month, mindex) in months">
						<template v-if="mindex < (n * 3) && mindex >= ((n - 1) * 3)">
							<div class="col-6 col-sm-4 col-md-3 col-lg-2">
								<div class="card shadow-sm mb-3" :class="{'bg-light': !month.form}">
									<div class="card-header card-header-action p-0 d-flex align-items-center justify-content-between" :class="{'bg-light': !month.form}">
										<router-link :to="'/knd/knd_forms_01/' + department.id + '/' + year + '/' + month.month + '/' + (month.form ? month.form.id : 'create')" class="p-2 text-decoration-none flex-fill text-dark text-small d-flex align-items-center text-truncate">
											<div class="text-truncate mx-2 fw-500">
												{{ month.month_name }}
											</div>
										</router-link>
									</div>
									<div class="card-body py-2 px-3 font-size-14">
										<template v-if="month.form">
											<span class="far fa-calendar fa-fw text-muted" v-b-tooltip="'Дата публикации отчета'"></span>
											{{ moment(month.form.form_date).format("DD MMMM YYYY") }}
										</template>
										<template v-else>
											Нет отчета
										</template>
									</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data () {
		return {
			moment: moment,
			department: null,
			year: null,
			months: null,
			isLoading: false
		}
	},
	mounted () {
		this.fetchData()
	},
	methods: {
		fetchData () {
			if (this.isLoading || !this.$route.params.departmentid) {
				return false
			}
			this.isLoading = true

			let url = process.env.VUE_APP_API_ROOT + '/api/knd/knd_forms_01/' + this.$route.params.departmentid + '/' + this.$route.params.year

			this
				.$http
				.get(url)
				.then(res => {
					this.months = res.data.months
					this.year = res.data.year
					this.department = res.data.department
				})
				.catch(err => {
					this.$notify({
					  group: 'main',
					  text: 'Ошибка получения форм',
					  duration: 3000,
					  type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		}
	},
	computed: {
		breadcrumbs () {
			let arr = []

			arr.push({
				to: '/',
				text: 'Главная'
			})

			arr.push({
				to: '/knd',
				text: 'Контрольно-надзорная деятельность'
			})

			arr.push({
				to: '/knd/knd_forms_01',
				text: 'Форма №1'
			})

			arr.push({
				to: '/knd/knd_forms_01/' + this.$route.params.departmentid,
				text: this.department ? this.department.title : 'Загрузка'
			})

			arr.push({
				active: true,
				text: this.$route.params.year ? this.$route.params.year : 'Загрузка'
			})

			return arr
		}
	}
}
</script>